module.exports = __webpack_public_path__ + "src/assets/games/19/228.jpg";